import React from 'react'
import { useAppSelector } from '../../../../store/hooks'
import { selectCrossClientLandingQueuedExecutions } from '../../../../store/crossClient/crossClientLanding'
import { CrossClientQueuedElement } from './CrossClientQueuedElement'

export const CrossClientLandingQueued: React.FC = () => {
  const queuedExecutions = useAppSelector(selectCrossClientLandingQueuedExecutions)

  return (
    <div className='d-flex flex-column gap-2 align-items-stretch w-100'>
      {queuedExecutions.length ? queuedExecutions.map((execution) => <CrossClientQueuedElement key={execution.id} execution={execution} />) : null}
    </div>
  )
}
